<style>
    .ordersynnart-table.table-bordered>thead>tr>th,
    .ordersynnart-table.table-bordered>tbody>tr>th,
    .ordersynnart-table.table-bordered>thead>tr>td,
    .ordersynnart-table.table-bordered>tbody>tr>td {
        line-height: 1.8 !important;
    }
</style>
<section [class.print-hide]="showprint">
    <div class="print-screen container" *ngIf="!accountCreateNotification">
        <div class="col-md-6 text-left left-padding-0">
            <button [disabled]="!(distributorInfo && distributorInfo.distributorId)" *ngIf="isTicketCreate && !orderInfo.tabForOrderPromotion" class="btn blue-button print-hide"
                (click)="createDisputeTicket()">+
                {{'customer-service.Ticket' |translate}}</button>
            <a [routerLink]="['/customerservice/orders']" routerLinkActive="active" (click)="createNewServiceOrder()"
                target="_blank" *ngIf="hasManageServiceOrderPermission && enableServiceOrder && !orderInfo.tabForOrderPromotion">
                <button  class="btn blue-button print-hide">+ {{'customer-service.Service Order' |translate}}</button>
            </a>
        </div>
            <div  class="right-align-block clearfix">
                <div *ngIf="memberInfo" class="text-right member-details-block word-break--overflow">
                    <div class="row">
                        <div class="col-md-12 text-right">
                            <span class="color-blue uppercase">{{'order.MEMBER DETAILS' |translate
                                    |translateKey}}</span>
                        </div>
                    </div>
                    <div *ngIf="memberInfo && memberInfo.firstName">
                        <div class="bold header-font color-black">
                            <span>{{memberInfo | displayNameFormat}}</span>
                        </div>
                        <div *ngIf="memberInfo.displayName && memberInfo.memberTypeId === memberTypeEnums.DISTRIBUTOR" class="bold">
                            <span>{{memberInfo.displayName | titleCase}}</span>
                          </div>
                        <div class="font14">
                            <a *ngIf="memberInfo?.fboId"><i class="fa fa-copy" [copyToClipboard]="memberInfo.fboId"></i></a>
                            <span *ngIf="memberInfo">
                                <span>{{memberInfo.fboId |distributorIdFormat}}</span> 
                                <span *ngIf="memberInfo?.fboId">| </span>
                                <span class="color-black"> {{memberInfo.memberTitle | uppercase}}</span>
                            </span>
                        </div>
                        <div class="font14">
                            <span>
                                <span *ngIf="hasCommissionActvityPermission && orderInformation && orderInformation.orderNumber && systemOrderNumberAcknowledgedFromAs400" class="color-blue" ><a (click)="getBonusRunStatusDetails('updateFBOIDofOrder')">{{'customer-service.Change FBOID on the Order' |translate}}</a> </span>
                                <span *ngIf="hasCommissionActvityPermission && orderInformation && orderInformation.orderNumber && systemOrderNumberAcknowledgedFromAs400 && memberInfo.emailForCommunication">|</span>
                                <span *ngIf="memberInfo.emailForCommunication" class="color-blue"> {{memberInfo.emailForCommunication}}</span>
                            </span>
                        </div>
                        <div class="font14" *ngIf="!memberInfo.emailForCommunication">
                            <span class="color-blue">{{memberInfo.email}}</span>
                        </div>
                        <div class="font14" *ngIf="distributorInfo && distributorInfo.privacyRequested">
                            {{'customer-service.Privacy Requested' |translate }}: <span [class.ERROR]="distributorInfo.privacyRequested === 'Yes'">{{'user.'+distributorInfo.privacyRequested |translate }}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div *ngIf="orderInformation">
                <div>
                    <ul class="list-group orderInfo-list-group">
                        <li class="list-group-item clearfix">
                            <div class="col-xs-6 no-padding">
                                <span class="header-font">
                                    {{'customer-service.Order' |translate}}
                                </span>
                            </div>
                            <div class="col-xs-6 right-padding-0">
                                <div class="">
                                    <span class="pull-right header-font">
                                      <img title="Print Invoice" *ngIf="showPrintOption "
                                       class="btn-label fa-pencil print-hide print-icon" type="button" (click)="printOrder()" [src]="printIconUrl">
                                      <span *ngIf="!orderInformation.orderNumber">{{orderInformation.webOrderId}} <span *ngIf="orderInformation && orderInformation.globalOrderNumber">/-/{{orderInformation.globalOrderNumber}}</span></span>
                                        <span *ngIf="orderInformation.orderNumber">{{orderInformation.webOrderId}}/{{orderInformation.orderNumber}}<span *ngIf="orderInformation && orderInformation.globalOrderNumber">/{{orderInformation.globalOrderNumber}}</span></span>
                                        <i title="Edit Order"
                                            *ngIf="(hasManageOrderPermission||hasManageServiceOrderUpdatePermission) && !orderInfo.tabForOrderPromotion  && orderInformation.billingInfo && orderInformation.billingInfo.paymentMethod &&
                                             (((paymentType.Wire_Transfer == orderInformation.billingInfo.paymentMethod || paymentType.Money_order == orderInformation.billingInfo.paymentMethod || paymentType.Orange_Money == orderInformation.billingInfo.paymentMethod || paymentType.Bank_Transfer == orderInformation.billingInfo.paymentMethod)
                                             && orderStatusId.Pending == orderInformation.orderStatusId) || (paymentType.Cash_On_Delivery == orderInformation.billingInfo.paymentMethod && (orderStatusId.Processing == orderInformation.orderStatusId
                                             || orderStatusId.Shipped == orderInformation.orderStatusId || orderStatusId.Ready_For_Pickup == orderInformation.orderStatusId) &&
                                             (paymentStatusEnum.PEND === orderInformation.orderPayments[0].paymentStatusId || paymentStatusEnum.PAYMENT_COMPLETED !== orderInformation.orderPayments[0].paymentStatusId)) || (hasManageOrderUpdatePermission && (orderStatusId.Processing == orderInformation.orderStatusId || orderStatusId.Shipped == orderInformation.orderStatusId || orderStatusId.Ready_For_Pickup == orderInformation.orderStatusId)))"
                                            id="edit" tabindex="0" type="button" class="fa fa-pencil color-blue print-hide"
                                            aria-hidden="true" (click)="editOrder()" (keyup.enter)="editOrder()"></i>
                                        <i title="Clone Order"
                                            *ngIf="hasManageOrderPermission && !orderInfo.tabForOrderPromotion && orderInformation.billingInfo && orderInformation.billingInfo.paymentMethod && (orderStatusId.Failed == orderInformation.orderStatusId) && enableCloneOrderFeature"
                                            id="edit" tabindex="0" type="button" class="fa fa-clone color-blue print-hide"
                                            aria-hidden="true" (click)="cloneOrder()" (keyup.enter)="cloneOrder()"></i>
                                        <i title="Cancel Order"
                                            *ngIf="showCancelIcon"
                                            tabindex="0" type="button" class="fa fa-close red-color pointer print-hide"
                                            aria-hidden="true" (click)="cancelOrderPopup()"
                                            (keyup.enter)="cancelOrderPopup()">
                                        </i>
                                        <ng-template #cancel_icon>
                                            <i title="Cancel Order"
                                            *ngIf="showCancelIcon"
                                            tabindex="0" type="button" class="fa fa-close red-color pointer print-hide"
                                            aria-hidden="true" (click)="cancelOrderPopup()"
                                            (keyup.enter)="cancelOrderPopup()"></i>
                                        </ng-template>
                                    </span>
                                </div>
                            </div>
                        </li>

                        <li class="list-group-item">
                            <div class="table-responsive orderdetails-table">
                                <table class="table">
                                    <thead>
                                        <tr>
                                            <th>
                                                {{'customer-service.Order Date' |translate}}
                                            </th>
                                            <th>
                                                {{'customer-service.Order Created On' |translate}}
                                            </th>
                                            <th>
                                                {{'customer-service.Total' |translate}}
                                            </th>
                                            <th>
                                                {{'customer-service.CC' |translate}}
                                            </th>
                                            <th>
                                                {{'customer-service.Source' |translate}}
                                            </th>
                                            <th *ngIf="displayUserName">
                                                {{'customer-service.Username' |translate}}
                                            </th>
                                            <th>
                                                {{'customer-service.Status' |translate}}
                                            </th>
                                            <th>
                                                {{'customer-service.Processing Period' |translate | translateKey}}
                                            </th>
                                            <th *ngIf="orderInformation && orderInformation.sponsorId ">
                                                {{'customer-service.Ref Sponsor' |translate | translateKey}}
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td *ngIf="orderInformation.orderPostedDate">
                                                {{orderInformation.orderPostedDate}}
                                            </td>
                                            <td *ngIf="!orderInformation.orderPostedDate">
                                                {{orderInformation.createdDate}}
                                            </td>
                                            <td>
                                                {{orderInformation.createdDate}}
                                            </td>
                                            <td>
                                                <!-- {{orderInformation.orderTotal |currencyFormat:storeInfo}} -->
                                                {{orderInformation.orderTotal | currencyFormat:storeInfo}}
                                            </td>
                                            <td *ngIf="showCCSnapshot">
                                                {{orderInformation.orderTotalCC |number:'1.3-3'}}
                                            </td>
                                            <td *ngIf="!showCCSnapshot">
                                                {{'customer-service.NA' |translate | translateKey}}
                                            </td>
                                            <td>
                                                {{orderInformation.source}}
                                            </td>
                                            <td *ngIf="displayUserName">
                                                {{orderInformation.userName}}
                                            </td>
                                            <td [class.ERROR]="orderInformation.orderStatus === 'Failed'">
                                                {{orderInformation.orderStatus}}
                                            </td>
                                            <td>
                                                <ng-container *ngIf="orderInformation?.processedMonth && orderInformation?.processedYear">
                                                    {{orderInformation.processedMonth <= 9 ? '0'+(orderInformation.processedMonth) : orderInformation.processedMonth }}/{{orderInformation.processedYear?.toString() |slice:2:4 }}
                                                    <span *ngIf="hasCommissionActvityPermission && orderInformation?.orderNumber && (orderInformation?.orderStatusId == orderStatusId.Processing || orderInformation?.orderStatusId == orderStatusId.Completed || orderInformation?.orderStatusId == orderStatusId.Shipped )  ">&nbsp;
                                                        <span *ngIf="systemOrderNumberAcknowledgedFromAs400"><i class="fa fa-pencil color-blue print-hide" (click)="editProcessingPeriod()"></i></span> 
                                                    </span>
                                                </ng-container>
                                            </td>
                                            <td *ngIf="orderInformation && orderInformation.sponsorId">
                                                {{orderInformation.sponsorId | distributorIdFormat}}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </li>
                    </ul>
                </div>
                <div class="table-responsive mb-20">
                    <table class="table table-striped custab">
                        <thead>
                            <tr>
                                <th tabindex="0">
                                    <strong>{{'customer-service.Item #' | translate}}
                                    </strong>
                                </th>
                                <th tabindex="0">
                                    <strong>{{'customer-service.Product Description' | translate}}
                                    </strong>
                                </th>
                                <th tabindex="0" class="text-right">
                                    <strong>{{'customer-service.Unit Price' | translate}}
                                    </strong>
                                </th>
                                <th tabindex="0" class="text-center">
                                    <strong>{{'customer-service.Quantity' | translate}}
                                    </strong>
                                </th>
                                <th tabindex="0" class="text-center">
                                    <strong>{{'customer-service.Total CC' |translate}}
                                    </strong>
                                </th>
                                <th tabindex="0" class="text-right">
                                    <strong>{{'customer-service.Price' |translate}}
                                    </strong>
                                </th>

                            </tr>
                        </thead>
                        <tbody *ngIf="orderInformation.orderLineItems && orderInformation.orderLineItems.length > 0">
                            <tr *ngFor="let productInfo of orderInformation.orderLineItems">
                                <ng-container *ngIf="!(productInfo.lineItemTypeId === OrderLineItemTypeEnum.CHILD_PRODUCT)">
                                    <td>
                                        <span *ngIf="!productInfo.depositFeeProduct">{{productInfo.itemNumber}}</span></td>
                                    <td class="">{{productInfo.productName}} </td>
                                    <td class="text-right"> {{productInfo.unitPaidPrice | currencyFormat:storeInfo}}</td>
                                    <td class="text-center">
                                        <span *ngIf="!productInfo.depositFeeProduct">{{productInfo.quantity}}</span></td>
                                    <td class="text-center" *ngIf="showCCSnapshot">
                                        <span *ngIf="!productInfo.depositFeeProduct">{{productInfo.totalQualificationValue| number:'1.3-3'}}</span></td>
                                    <td class="text-center" *ngIf="!showCCSnapshot">
                                        <span *ngIf="!productInfo.depositFeeProduct">{{'customer-service.NA' |translate | translateKey}}</span></td>
                                    <td class="text-right">{{productInfo.totalAmount | currencyFormat:storeInfo}}</td>
                                </ng-container>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div class="row-sameheight-block word-break--overflow page-break"  style="margin-bottom:20px;">
                    <div class="column-equal border-1"  style="border: 1px solid #0f7bb6; padding:15px">
                        <div class="border-sizing">
                            <div class="row">
                                <div class="col-sm-6 col-md-12 text-right"
                                    *ngIf="orderInformation && orderInformation.orderShippings.length > 0 && (orderInformation.orderShippings[0].deliveryPreferenceId === 1)">
                                    <span class="color-blue">{{'customer-service.SHIP TO' |translate}}</span>
                                </div>
                                <div class="col-sm-6 col-md-12 text-right"
                                    *ngIf="orderInformation && orderInformation.orderShippings.length > 0 && (orderInformation.orderShippings[0].deliveryPreferenceId === 2)">
                                    <span class="color-blue">{{'customer-service.PICK UP' |translate}}</span>
                                </div>
                                <div class="col-sm-6 col-md-12 text-right"
                                    *ngIf="orderInformation && orderInformation.orderShippings.length > 0 && ( orderInformation.orderShippings[0].deliveryPreferenceId === 42 )">
                                    <span class="color-blue">{{'customer-service.DROP SHIP' |translate}}</span>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-3 col-md-3">
                                    <span>{{'customer-service.Name' |translate}}</span>
                                </div>
                                <div class="col-sm-9 col-md-9 text-right word-break"
                                    *ngIf="orderInformation && orderInformation.orderShippings.length > 0 && (orderInformation.orderShippings[0].deliveryPreferenceId === 2 || orderInformation.orderShippings[0].deliveryPreferenceId === 42)">
                                    <span *ngIf="shipToAddressName">{{ shipToAddressName | titleCase }} </span>

                                </div>
                                <div  [ngClass] ="orderInformation && orderInformation.orderShippings.length > 0 && (orderInformation.orderShippings[0].deliveryPreferenceId === 1) && !shipToAddressName ? 'col-sm-9 col-md-9 text-right word-break' : 'col-sm-12 col-md-12 text-right word-break'"
                                    *ngIf="orderInformation && orderInformation.orderShippings.length > 0 && (orderInformation.orderShippings[0].deliveryPreferenceId === 1 || orderInformation.orderShippings[0].deliveryPreferenceId === 42)">
                                    <span>{{orderInformation.shippingInfo.address.firstName | titleCase}}
                                        {{orderInformation.shippingInfo.address.middleName | titleCase}}
                                        {{orderInformation.shippingInfo.address.lastName | titleCase}}</span>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-3 col-md-3">
                                    <span>{{'customer-service.Address' |translate}}</span>
                                </div>
                                <div class="col-sm-9 col-md-9 text-right">
                                    <span class="billToAddress">{{orderInformation.shippingInfo.address.addressLine1}}</span>
                                </div>
                                <div class="col-sm-7 col-md-7 col-sm-offset-5 col-md-offset-5 text-right"
                                    *ngIf="orderInformation.shippingInfo.address.addressLine2">
                                    <span class="billToAddress">{{orderInformation.shippingInfo.address.addressLine2}}</span>
                                </div>
                                <div class="col-sm-7 col-md-7 col-sm-offset-5 col-md-offset-5 text-right"
                                      *ngIf="orderInformation.shippingInfo.address.addressLine3">
                                      <span class="billToAddress">{{orderInformation.shippingInfo.address.addressLine3}}</span>
                                </div>
                                <div class="col-sm-7 col-md-7 col-sm-offset-5 col-md-offset-5 text-right"
                                    *ngIf="orderInformation.shippingInfo.address.addressLine4">
                                    <span class="billToAddress">{{orderInformation.shippingInfo.address.addressLine4}}</span>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-5 col-md-5">
                                    <span>{{'customer-service.City' |translate}}</span>
                                </div>
                                <div class="col-sm-7 col-md-7 text-right">
                                    <span class="billToAddress">{{orderInformation.shippingInfo.address.city}} </span>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-sm-5 col-md-5">
                                    <span *ngIf="shippingAddressInfoConfig && shippingAddressInfoConfig.displayStateCode">{{'customer-service.State/Zipcode' |translate}}</span>
                                    <span *ngIf="shippingAddressInfoConfig && !shippingAddressInfoConfig.displayStateCode">{{'customer-service.Zipcode' |translate}}</span>
                                </div>
                                <div class="col-sm-7 col-md-7 text-right">
                                    <span><span *ngIf="shippingAddressInfoConfig && shippingAddressInfoConfig.displayStateCode">{{orderInformation.shippingInfo.address.state}}</span>
                                        {{orderInformation.shippingInfo.address.zipCode}}</span>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-5 col-md-5">
                                    <span>{{'customer-service.Country' |translate}}</span>
                                </div>
                                <div class="col-sm-7 col-md-7 text-right">
                                    <span>{{orderInformation.shippingInfo.address.country |uppercase}}</span>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-5 col-md-5">
                                    <span>{{'customer-service.Ship Phone' |translate |translateKey}}</span>
                                </div>
                                <div class="col-sm-7 col-md-7 text-right">
                                    <span *ngIf="orderInformation?.shippingInfo?.address?.phone">{{orderInformation?.shippingInfo?.address?.phone | mask: phoneNumberFormat}}</span>
                                    <span *ngIf="!orderInformation?.shippingInfo?.address?.phone">{{'customer-service.NA' |translate |translateKey}}</span>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-5 col-md-5">
                                    <span>{{'customer-service.Ship Email' |translate |translateKey}}</span>
                                </div>
                                <div class="col-sm-7 col-md-7 text-right">
                                    <span *ngIf ="orderInformation?.shippingInfo?.address?.email">{{orderInformation.shippingInfo.address.email}}</span>
                                    <span *ngIf="!orderInformation?.shippingInfo?.address?.email">{{'customer-service.NA' |translate |translateKey}}</span>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-5 col-md-5">
                                    <label>{{'customer-service.Date Shipped' |translate | translateKey}}</label>
                                </div>
                                <!-- <div class="col-md-7 text-right" *ngIf="orderInformation.shippingInfo.shippingDate">
                                         &nbsp; {{ orderInformation.shippingInfo.shippingDate|date:'dd-MMM-yyyy' }}
                                    </div>-->
                                <div class="col-sm-7 col-md-7 text-right">
                                    &nbsp; {{'customer-service.NA' |translate |translateKey}}
                                </div>
                            </div>
                            <!-- <div class="row">
                                <div class="col-md-5">
                                    <span>{{'customer-service.Shipped Weight' |translate | translateKey}}</span>
                                </div>
                                <div class="col-md-7 text-right">
                                    <span>{{orderInformation.shippingWeight}}</span>
                                </div>
                            </div> -->
                            <div class="row">
                                <div class="col-sm-5 col-md-5">
                                    <span>{{'customer-service.Warehouse Name' |translate}}</span>
                                </div>
                                <div class="col-sm-7 col-md-7 text-right">
                                    <span *ngIf="!orderInformation.shippingInfo.warehouse">{{'customer-service.NA'
                                        |translate}}</span>
                                    <span
                                        *ngIf="orderInformation.shippingInfo.warehouse">{{orderInformation.shippingInfo.warehouse}}</span>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-5 col-md-5">
                                    <span>{{'customer-service.Shipping Method' |translate}}</span>
                                </div>
                                <div class="col-sm-7 col-md-7 text-right"
                                    *ngIf="orderInformation && orderInformation.orderShippings.length > 0 && (orderInformation.orderShippings[0].deliveryPreferenceId === 1 || orderInformation.orderShippings[0].deliveryPreferenceId === 42)">
                                    <span
                                        *ngIf="orderInformation.shippingInfo.shippingMethod">{{orderInformation.shippingInfo.shippingMethod}}</span>
                                    <span *ngIf="!orderInformation.shippingInfo.shippingMethod">{{'customer-service.NA'
                                        |translate | translateKey}}</span>
                                </div>
                                <div class="col-sm-7 col-md-7 text-right"
                                    *ngIf="orderInformation && orderInformation.orderShippings.length > 0 && (orderInformation.orderShippings[0].deliveryPreferenceId === 2)">
                                    <span>{{'customer-service.NA' |translate}}</span>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-5 col-md-5">
                                    <span>Tracking Number</span>
                                </div>
                                <div class="col-sm-7 col-md-7 text-right" *ngIf="shipTrackingUrl">
                                    <a href="{{shipTrackingUrl}}" target="_blank">{{orderInformation.orderNumber}}</a>
                                </div>
                                <div class="col-sm-7 col-md-7 text-right" *ngIf="!shipTrackingUrl&&trackingModel">
                                <ng-container *ngFor="let trackingUrl of trackingUrls ;let i=index">
                                <div >
                                  <a href="{{trackingUrl}}" target="_blank">Parcel{{i+1}}</a>
                                </div>
                              </ng-container>
                              </div>
                                <div class="col-sm-7 col-md-7 text-right" *ngIf="!shipTrackingUrl && !trackingModel">
                                    <span>{{'customer-service.NA' |translate}}</span>
                                </div>
                            </div>
                            <div class="row" *ngIf="orderInformation.shippingInfo.address && showDeliveryInstructions">
                                <div class="col-sm-5 col-md-5">
                                    <span>{{'customer-service.Delivery Instructions' |translate}}</span>
                                </div>
                                <div class="col-sm-7 col-md-7 text-right">
                                    <span class="billToAddress">{{orderInformation.shippingInfo.address.deliveryInstruction}}</span>
                                    <span *ngIf="!orderInformation.shippingInfo.address.deliveryInstruction">{{'customer-service.NA' |translate |
                                        translateKey}}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="column-equal" style="margin-left: auto;">
                        <div class="table-responsive">
                            <table class="ordersynnart-table table table-striped table-bordered custab">
                                <thead>
                                    <tr>
                                        <th>{{'customer-service.Order Summary' |translate}}</th>
                                        <th class="text-right">{{'customer-service.Amount' |translate}}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr
                                        *ngIf="memberTypeId != memberTypeEnums.GUEST && memberTypeId != memberTypeEnums.RETAIL && orderTypeId != purchaseFlowEnum.Enrollment">
                                        <td>{{'customer-service.Retail Subtotal' |translate |translateKey}}</td>
                                        <td class="text-right">{{(retailSubTotal ? retailSubTotal:0) |
                                            currencyFormat:storeInfo}}</td>
                                    </tr>
                                    <tr>
                                        <td>{{'customer-service.Sub Total' |translate}}</td>
                                        <td class="text-right">{{(orderInformation.orderSubTotal ?
                                            orderInformation.orderSubTotal : 0) | currencyFormat:storeInfo}}</td>
                                        <!-- <td class="text-right" *ngIf="!orderInformation.orderSubTotal">{{'-'}}</td> -->

                                    </tr>
                                    <tr>
                                        <td
                                            *ngIf="orderInformation && orderInformation.orderShippings && orderInformation.orderShippings.length > 0 && orderInformation.orderShippings[0].deliveryPreferenceId === deliveryPreference.DELIVERY">{{'customer-service.Shipping'
                                            |translate |translateKey}}</td>
                                        <td
                                            *ngIf="orderInformation && orderInformation.orderShippings && orderInformation.orderShippings.length > 0 && (orderInformation.orderShippings[0].deliveryPreferenceId === deliveryPreference.PICKUP || orderInformation.orderShippings[0].deliveryPreferenceId === deliveryPreference.DROPSHIP)">{{'customer-service.Handling'
                                            |translate |translateKey}}</td>
                                        <td class="text-right">{{ shippingCost | currencyFormat:storeInfo}}</td>
                                        <!-- <td class="text-right" *ngIf="!orderInformation.shippingCost">{{'-'}}</td> -->
                                    </tr>
                                    <tr
                                        *ngIf="orderLevelDiscount > 0">
                                        <td>{{'customer-service.Order Level Discount' |translate |translateKey}}</td>
                                        <td class="text-right">- {{(orderLevelDiscount ? orderLevelDiscount:0) |
                                            currencyFormat:storeInfo}}</td>
                                    </tr>
                                    <tr
                                        *ngIf="orderInformation && orderInformation.countryCode && appConfig?.displayTax">
                                        <td>{{'customer-service.Taxes' |translate}}</td>
                                        <td class="text-right" >{{(orderInformation.orderTax? retailDeliveryFee? orderInformation.orderTax - retailDeliveryFee : orderInformation.orderTax : 0) | currencyFormat:storeInfo}}</td>
                                    </tr>
                                <ng-container *ngIf="storeInfo?.taxInclusive && ((orderInformation?.vatRegistered == true && !appConfig.enableVatItemizationForNonVat)|| appConfig?.displayVat) && orderInformation?.taxMetaData?.orderTaxCharges && !appConfig?.displayTaxInclusivePrice">
                                    <tr *ngFor="let item of orderInformation?.taxMetaData?.orderTaxCharges | orderBy:'taxRate' | groupBy:['taxChargeType','taxRate'];let i=index;trackBy:trackByItem">
                                            <td *ngIf="item.value[0].taxRate > 0">{{'customer-service.VAT' | translate | translateKey}} <span *ngIf="appConfig.displayTaxCode">({{item.value[0].taxChargeType}}) {{item.value[0].taxRate}}%</span>
                                                <span *ngIf="!appConfig.displayTaxCode">({{item.value[0].taxRate}}%)</span></td>
                                            <td class="text-right" *ngIf="item.value[0].taxRate > 0">{{ getItemVolumeSum(item.value) | currencyFormat:storeInfo}}
                                            </td>
                                    </tr>
                                </ng-container>
                                <ng-container *ngIf="storeInfo?.taxInclusive && appConfig?.displayCustomTaxName && orderInformation?.taxMetaData?.orderTaxCharges">
                                    <tr *ngFor="let item of orderInformation?.taxMetaData?.orderTaxCharges | orderBy:'taxRate' | groupBy:['taxChargeType','taxRate'];let i=index;trackBy:trackByItem">
                                            <td *ngIf="item.value[0].taxChargeType === taxType.NOR && item.value[0].taxRate > 0">{{'customer-service.GST' | translate}}</td>
                                            <td *ngIf="item.value[0].taxChargeType === taxType.NOR  && item.value[0].taxRate > 0" class="text-right">{{ getItemVolumeSum(item.value) | currencyFormat:storeInfo}}
                                            </td>
                                    </tr>
                                </ng-container>
                                    <tr
                                        *ngIf="orderInformation && orderInformation.countryCode && orderInformation.countryCode.toLowerCase() === 'can'">
                                        <td>{{'customer-service.GST/HST' |translate}}</td>
                                        <td class="text-right">{{(gstTax? gstTax : 0) | currencyFormat:storeInfo}}</td>
                                    </tr>
                                    <tr
                                        *ngIf="orderInformation && orderInformation.countryCode && orderInformation.countryCode.toLowerCase() === 'can'">
                                        <td>{{'customer-service.PST/QST' |translate}}</td>
                                        <td class="text-right">{{(pstTax? pstTax : 0) | currencyFormat:storeInfo}}</td>
                                    </tr>
                                    <tr>
                                        <td>{{'customer-service.Fees' |translate}}</td>
                                        <td class="text-right">{{(orderInformation.importFeeValue ?
                                            orderInformation.importFeeValue : 0) | currencyFormat:storeInfo}}</td>
                                        <!-- <td class="text-right" *ngIf="!orderInformation.importFeeValue">{{'-'}}</td> -->
                                    </tr>
                                    <tr *ngIf="retailDeliveryFee">
                                        <td>{{'customer-service.Retail Delivery Fee' |translate |translateKey}}</td>
                                        <td class="text-right">{{(retailDeliveryFee ? retailDeliveryFee : 0) | currencyFormat:storeInfo}}</td>
                                    </tr>
                                    <tr *ngIf="orderInformation && orderInformation.isDM && orderInformation.totalDiscountAmount">
                                        <td>{{'customer-service.Discount' |translate}}</td>
                                        <td class="text-right">-{{orderInformation.totalDiscountAmount | currencyFormat:storeInfo}}</td>
                                        <!-- <td class="text-right" *ngIf="!orderInformation.importFeeValue">{{'-'}}</td> -->
                                    </tr>
                                    <tr class="bold" *ngIf="appConfig?.displayTaxInclusivePrice">
                                        <td>{{'customer-service.Total CC' |translate |translateKey}}</td>
                                        <td class="text-right" *ngIf="showCCSnapshot">{{orderInformation.orderTotalCC|
                                            number:'1.3-3'}}</td>
                                        <td class="text-right" *ngIf="!showCCSnapshot">{{'customer-service.NA' |translate |
                                            translateKey}}</td>
                                    </tr>
                                    <tr class="bold">
                                        <td>{{'customer-service.Total' |translate}}</td>
                                        <td class="text-right">{{(orderInformation.orderTotal ?
                                            orderInformation.orderTotal: 0) | currencyFormat:storeInfo}}</td>
                                        <!-- <td class="text-right" *ngIf="!total">{{orderInformation.orderTotal | currencyFormat:storeInfo}}</td> -->
                                    </tr>
                                    <tr class="bold" *ngIf="!appConfig?.displayTaxInclusivePrice">
                                        <td>{{'customer-service.Total CC' |translate |translateKey}}</td>
                                        <td class="text-right" *ngIf="showCCSnapshot">{{orderInformation.orderTotalCC|
                                            number:'1.3-3'}}</td>
                                        <td class="text-right" *ngIf="!showCCSnapshot">{{'customer-service.NA' |translate |
                                            translateKey}}</td>
                                    </tr>
                                    <ng-container *ngIf="storeInfo?.taxInclusive && ((orderInformation?.vatRegistered == true && !appConfig.enableVatItemizationForNonVat)|| appConfig?.displayVat) && orderInformation?.taxMetaData?.orderTaxCharges && appConfig?.displayTaxInclusivePrice">
                                        <tr *ngFor="let item of orderInformation?.taxMetaData?.orderTaxCharges | orderBy:'taxRate' | groupBy:['taxChargeType','taxRate'];let i=index;trackBy:trackByItem">
                                            <td *ngIf="item.value[0].taxRate > 0">{{'customer-service.Includes' | translate | translateKey}} <span *ngIf="appConfig?.displayTaxCode">{{item.value[0].taxRate}} % {{'customer-service.VAT' | translate | translateKey}}</span>
                                               <span *ngIf="!appConfig?.displayTaxCode">({{item.value[0].taxRate}}%)</span></td>
                                           <td class="text-right" *ngIf="item.value[0].taxRate > 0">{{ getItemVolumeSum(item.value) | currencyFormat:storeInfo}}
                                           </td>
                                       </tr>
                                    </ng-container>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

                <div class="row-sameheight-block word-break--overflow page-break" style="margin-bottom:20px;">
                    <div class="column-equal border-1" style="border: 1px solid #0f7bb6; padding:15px">
                        <div class="row">
                            <div class="col-md-12 text-right">
                                <span class="color-blue">{{'customer-service.BILL TO' |translate}}</span>
                            </div>
                        </div>

                        <!--<div *ngIf="orderInformation.billingInfo && orderInformation.billingInfo.address;else shippingAddress">-->
                        <div *ngIf="orderInformation.billingInfo ">
                            <div class="row">
                                <div class="col-sm-3 col-md-3">
                                    <span>{{'customer-service.Name' |translate}}</span>
                                </div>
                                <div class="col-sm-9 col-md-9 text-right" *ngIf="orderInformation.billingInfo.billingAddress">
                                    <!-- <span *ngIf="orderInformation.billingInfo.billingAddress.name || orderInformation.billingInfo.cardHolderName">{{this.paymentmethod | titleCase}}</span> -->
                                    <span *ngIf="orderInformation.billingInfo.billingAddress.name || orderInformation.billingInfo.cardHolderName">{{orderInformation.billingInfo.billingAddress.name || orderInformation.billingInfo.cardHolderName
                                        | titleCase}}</span>
                                    <span *ngIf="!(orderInformation.billingInfo.billingAddress.name || orderInformation.billingInfo.cardHolderName)">{{'customer-service.NA'
                                        |translate}}</span>
                                </div>
                                <div class="col-sm-9 col-md-9 text-right" *ngIf="!orderInformation.billingInfo.billingAddress">
                                    <span>{{'customer-service.NA' |translate}}</span>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-3 col-md-3">
                                    <span>{{'customer-service.Address' |translate}}</span>
                                </div>
                                <div class="col-sm-9 col-md-9 text-right" *ngIf="orderInformation.billingInfo.billingAddress">
                                    <span class="billToAddress"
                                        *ngIf="orderInformation.billingInfo.billingAddress.addressLine1 && !this.billingAddressMode">
                                        {{orderInformation.billingInfo.billingAddress.addressLine1}}</span>
                                    <span *ngIf="!orderInformation.billingInfo.billingAddress.addressLine1 && !this.billingAddressMode">{{'customer-service.NA'
                                        |translate}}</span>
                                </div>
                                <div class="col-sm-9 col-md-9 text-right" *ngIf="!orderInformation.billingInfo.billingAddress">
                                    {{'customer-service.NA' |translate}}
                                </div>
                                <div *ngIf="orderInformation.billingInfo.billingAddress && !this.billingAddressMode"
                                    class="col-sm-7 col-md-7 col-sm-offset-5 col-md-offset-5 text-right">
                                    <span class="billToAddress">{{orderInformation.billingInfo.billingAddress.addressLine2}}</span>
                                </div>
                            </div>
                            <div class="row">
                                    <div class="col-sm-5 col-md-5">
                                        <span>{{'customer-service.City' |translate}}</span>
                                    </div>
                                    <div class="col-sm-7 col-md-7 text-right" *ngIf="orderInformation.billingInfo.billingAddress">
                                        <span class="billToAddress"
                                            *ngIf="orderInformation.billingInfo.billingAddress.city && !this.billingAddressMode">{{orderInformation.billingInfo.billingAddress.city}}
                                        </span>
                                        <span *ngIf="!orderInformation.billingInfo.billingAddress.city">{{'customer-service.NA'
                                            |translate}}</span>
                                    </div>
                                    <div class="col-sm-7 col-md-7 text-right" *ngIf="!orderInformation.billingInfo.billingAddress">
                                        {{'customer-service.NA' |translate}}
                                    </div>
                            </div>

                            <div class="row">
                                <div class="col-sm-5 col-md-5">
                                    <span *ngIf="shippingAddressInfoConfig && shippingAddressInfoConfig.displayStateCode">{{'customer-service.State/Zipcode' |translate}}</span>
                                    <span *ngIf="shippingAddressInfoConfig && !shippingAddressInfoConfig.displayStateCode">{{'customer-service.Zipcode' |translate}}</span>
                                </div>
                                <div class="col-sm-7 col-md-7 text-right" *ngIf="orderInformation.billingInfo.billingAddress">
                                    <span
                                        *ngIf="orderInformation.billingInfo.billingAddress.state || orderInformation.billingInfo.billingAddress.zip">
                                        <span *ngIf="shippingAddressInfoConfig && shippingAddressInfoConfig.displayStateCode && !this.billingAddressMode"> {{orderInformation.billingInfo.billingAddress.state}}</span>
                                        {{orderInformation.billingInfo.billingAddress.zip}}</span>
                                    <span
                                        *ngIf="!orderInformation.billingInfo.billingAddress.state && !orderInformation.billingInfo.billingAddress.zip">
                                        {{'customer-service.NA' |translate}}</span>
                                </div>
                                <div class="col-sm-7 col-md-7 text-right" *ngIf="!orderInformation.billingInfo.billingAddress">
                                    <span>{{'customer-service.NA' |translate}}</span>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-5 col-md-5">
                                    <span>{{'customer-service.Country' |translate}}</span>
                                </div>
                                <div class="col-sm-7 col-md-7 text-right" *ngIf="orderInformation.billingInfo.billingAddress">
                                    <span *ngIf="orderInformation.billingInfo.billingAddress.countryCode">{{orderInformation.billingInfo.billingAddress.countryCode
                                        |uppercase}}</span>
                                    <span *ngIf="!orderInformation.billingInfo.billingAddress.countryCode">{{'customer-service.NA'
                                        |translate}}</span>
                                </div>
                                <div class="col-sm-7 col-md-7 text-right" *ngIf="!orderInformation.billingInfo.billingAddress">
                                    <span>{{'customer-service.NA' |translate}}</span>
                                </div>
                            </div>
                        </div>
                        <!--<ng-template #shippingAddress>
                            <div *ngIf="orderInformation.shippingInfo && orderInformation.shippingInfo.address">
                                <div class="row">
                                    <div class="col-md-3">
                                        <span>{{'customer-service.Name' |translate}}</span>
                                    </div>
                                    <div class="col-md-9 text-right" *ngIf="orderInformation && orderInformation.orderShippings.length > 0 && !(orderInformation.orderShippings[0].deliveryPreferenceId === 2)">
                                        {{orderInformation.shippingInfo.address.name | titlecase}}
                                    </div>
                                    <div class="col-md-9 text-right" *ngIf="orderInformation && orderInformation.orderShippings.length > 0 && (orderInformation.orderShippings[0].deliveryPreferenceId === 2)">
                                        <span>{{'customer-service.NA' |translate}}</span>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-3">
                                        <span>{{'customer-service.Address' |translate}}</span>
                                    </div>
                                    <div class="col-md-9 text-right">
                                        <div *ngIf="orderInformation.shippingInfo.address.addressLine1" class="">
                                            <span>{{orderInformation.shippingInfo.address.addressLine1 | titlecase}}</span>
                                        </div>
                                    </div>

                                </div>
                                <div class="row">
                                    <div class="col-md-5">
                                        <span>{{'customer-service.City' |translate}}</span>
                                    </div>
                                    <div class="col-md-7 text-right">
                                        <span>{{orderInformation.shippingInfo.address.city}} </span>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-md-5">
                                        <span>{{'customer-service.State/Zipcode' |translate}}</span>
                                    </div>
                                    <div class="col-md-7 text-right">
                                        <span>{{orderInformation.shippingInfo.address.state}} {{orderInformation.shippingInfo.address.zipCode}}</span>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-5">
                                        <span>{{'customer-service.Country' |translate}}</span>
                                    </div>
                                    <div class="col-md-7 text-right">
                                        <span>{{orderInformation.shippingInfo.address.country |uppercase}}</span>
                                    </div>
                                </div>
                            </div>

                        </ng-template>-->

                    </div>
                    <div class="column-equal border-1" style="margin-left: auto; border: 1px solid #0f7bb6; padding:15px">
                        <div class="row">
                            <div class="col-md-12 text-right">
                                <span class="color-blue">{{'customer-service.PAY BY' |translate}}</span>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-sm-5 col-md-5">
                                <span>{{'order.Payment Method' |translate}}</span>
                            </div>
                            <div class="col-sm-7 col-md-7 text-right" *ngIf="!orderInformation.billingInfo.paymentMethod">
                                <span>{{'customer-service.NA' |translate}}</span>
                            </div>
                            <div class="col-sm-7 col-md-7 text-right" *ngIf="orderInformation.billingInfo.paymentMethod">
                                <span
                                    *ngIf="orderInformation.billingInfo.paymentMethod === paymentType.Credit_Card">{{paymentMethodTypeConstants.Credit_Card}}</span>
                                <span *ngIf="orderInformation.billingInfo.paymentMethod === paymentType.Google_Pay">{{paymentMethodTypeConstants.Google_Pay}}</span>
                                <!-- <span
                                    *ngIf="orderInformation.billingInfo.paymentMethod === paymentType.eCheck">{{paymentMethodTypeConstants.eCheck}}</span> -->
                                <span
                                    *ngIf="orderInformation.billingInfo.paymentMethod === paymentType.Apple_Pay">{{paymentMethodTypeConstants.Apple_Pay}}</span>
                                <span
                                    *ngIf="orderInformation.billingInfo.paymentMethod === paymentType.ApplePay_Adyen">{{paymentMethodTypeConstants.ApplePay_Adyen}}</span>
                                    <span
                                    *ngIf="orderInformation.billingInfo.paymentMethod === paymentType.GooglePay_Adyen">{{paymentMethodTypeConstants.GooglePay_Adyen}}</span>
                                <span
                                    *ngIf="orderInformation.billingInfo.paymentMethod === paymentType.Credit_Card_External">{{paymentMethodTypeConstants.Credit_Card_External}}</span>
                                <span
                                    *ngIf="orderInformation.billingInfo.paymentMethod === paymentType.Money_order && !appConfig.displayStatementForWavePayment">{{paymentMethodTypeConstants.Money_Order}}</span>
                               <span
                                    *ngIf="orderInformation.billingInfo.paymentMethod === paymentType.Money_order && appConfig.displayStatementForWavePayment">{{paymentMethodTypeConstants.Wave}}</span>
                                <span
                                    *ngIf="orderInformation.billingInfo.paymentMethod === paymentType.Orange_Money && appConfig.displayStatementForWavePayment">{{paymentMethodTypeConstants.Orange_Money}}</span>
                                <span
                                    *ngIf="orderInformation.billingInfo.paymentMethod === paymentType.Blik">{{paymentMethodTypeConstants.Blik}}</span>
                                <span
                                    *ngIf="orderInformation.billingInfo.paymentMethod === paymentType.Wire_Transfer">{{paymentMethodTypeConstants.Wire_Transfer}}</span>
                                <span
                                    *ngIf="orderInformation.billingInfo.paymentMethod === paymentType.PayPal">{{paymentMethodTypeConstants.Paypal}}</span>
                                <span
                                    *ngIf="orderInformation.billingInfo.paymentMethod === paymentType.Giro_Pay">{{paymentMethodTypeConstants.Giro_Pay}}</span>
                                <span
                                    *ngIf="orderInformation.billingInfo.paymentMethod === paymentType.Eps">{{paymentMethodTypeConstants.Eps}}</span>
                                <span
                                    *ngIf="orderInformation.billingInfo.paymentMethod === paymentType.Cash">{{paymentMethodTypeConstants.Cash}}</span>
                                <span
                                    *ngIf="orderInformation.billingInfo.paymentMethod === paymentType.Cash_On_Delivery">{{paymentMethodTypeConstants.Cash_On_Delivery}}</span>
                                <span
                                    *ngIf="orderInformation.billingInfo.paymentMethod === paymentType.Bank_Transfer">{{paymentMethodTypeConstants.Bank_Transfer}}</span>
                                <span
                                    *ngIf="orderInformation.billingInfo.paymentMethod === paymentType.Pos">Pos</span>
                                <span
                                    *ngIf="orderInformation.billingInfo.paymentMethod === paymentType.Prdpay">Prdpay</span>
                                <span
                                    *ngIf="orderInformation.billingInfo.paymentMethod === paymentType.Pay_By_Link">{{paymentMethodTypeConstants.Pay_By_Link}}</span>
                                <span
                                    *ngIf="orderInformation.billingInfo.paymentMethod === paymentType.eCheck">eCheck</span>
                                <span
                                    *ngIf="orderInformation.billingInfo.paymentMethod === paymentType.Bonus_Check">{{paymentMethodTypeConstants.Bonus_Check}}
                                  </span>

                                <span *ngIf="orderInformation.billingInfo.paymentMethod === paymentType.Personal_Check">{{paymentMethodTypeConstants.Personal_Check}}</span>

                                <span *ngIf="orderInformation.billingInfo.paymentMethod === paymentType.Travelers_Check">{{paymentMethodTypeConstants.Travelers_Check}}</span>

                                <span *ngIf="orderInformation.billingInfo.paymentMethod === paymentType.BanContact_MisterCash_and_Maestro">{{paymentMethodTypeConstants.BanContact_MisterCash_and_Maestro}}</span>

                                <span *ngIf="orderInformation.billingInfo.paymentMethod === paymentType.MisterCash_and_Maestro">{{paymentMethodTypeConstants.MisterCash_and_Maestro}}</span>

                                <span *ngIf="orderInformation.billingInfo.paymentMethod === paymentType.Integrated_Terminal_Adyen">{{paymentMethodTypeConstants.Integrated_Terminal_Adyen}}</span>

                                <span *ngIf="orderInformation.billingInfo.paymentMethod === paymentType.Service_Order">{{paymentMethodTypeConstants.Service_Order}}</span>
                                <span class="text-right" *ngIf="orderInformation.billingInfo.paymentMethod === paymentType.Trustly">{{orderInformation.billingInfo.paymentMethod}}</span>
                                <span class="text-right"  *ngIf="orderInformation.billingInfo.paymentMethod === paymentType.MobilePay">{{orderInformation.billingInfo.paymentMethod}}</span>
                                <span class="text-right"  *ngIf="orderInformation.billingInfo.paymentMethod === paymentType.Vipps">{{orderInformation.billingInfo.paymentMethod}}</span>
                                <span class="text-right"  *ngIf="orderInformation.billingInfo.paymentMethod === paymentType.Swish">{{orderInformation.billingInfo.paymentMethod}}</span>
                                <span *ngIf="orderInformation.billingInfo.paymentMethod === paymentType.Single_Debit">{{paymentMethodTypeConstants.Single_Debit}}</span>
                                <span *ngIf="orderInformation.billingInfo.paymentMethod === paymentType.Direct_Debit">{{paymentMethodTypeConstants.Direct_Debit}}</span>
                                <span *ngIf="orderInformation.billingInfo.paymentMethod === paymentType.Ideal">{{paymentMethodTypeConstants.Ideal}}</span>
                                <span *ngIf="orderInformation.billingInfo.paymentMethod === paymentType.Walley">{{paymentMethodTypeConstants.Walley}}</span>
                                <span *ngIf="orderInformation.billingInfo.paymentMethod === paymentType.Twint">{{paymentMethodTypeConstants.Twint}}</span>
                                <span *ngIf="orderInformation.billingInfo.paymentMethod === paymentType.Dori_Pay">{{paymentMethodTypeConstants.Dori_Pay}}</span>
                                <span *ngIf="orderInformation.billingInfo.paymentMethod === paymentType.Riverty">{{paymentMethodTypeConstants.Riverty}}</span>

                            </div>

                            
                        </div>
                        <div *ngIf="((orderInformation.billingInfo.paymentMethod === paymentType.Money_order || orderInformation.billingInfo.paymentMethod === paymentType.Orange_Money) && appConfig.displayStatementForWavePayment)">
                            <div class="row">
                                <div class="col-md-6">
                                    <label>Payment Reference Number:</label>
                                </div>
                                <div class="col-md-6">
                                    <span class="pull-right">{{orderInformation.orderPayments[0].authCode}}</span>
                                </div>
                            </div>
                        </div>
                        <!-- <div class="row" *ngIf="paymentType.eCheck==orderInformation.billingInfo.paymentMethod">
                            <div class="col-sm-5 col-md-5">
                                <span>{{'order.Bank Name' |translate}}</span>
                            </div>
                            <div class="col-sm-7 col-md-7 text-right" *ngIf="!orderInformation.billingInfo.bankName">
                                <span>{{'customer-service.NA' |translate}}</span>
                            </div>
                            <div class="col-sm-7 col-md-7 text-right" *ngIf="orderInformation.billingInfo.bankName">

                                <span>{{orderInformation.billingInfo.bankName}}</span>
                            </div>
                        </div>
                        <div class="row" *ngIf="paymentType.eCheck==orderInformation.billingInfo.paymentMethod">
                            <div class="col-sm-5 col-md-5">
                                <span>{{'order.Accountholder' |translate}}</span>
                            </div>
                            <div class="col-sm-7 col-md-7 text-right" *ngIf="!orderInformation.billingInfo.nameOnBankAccount">
                                <span>{{'customer-service.NA' |translate}}</span>
                            </div>
                            <div class="col-sm-7 col-md-7 text-right" *ngIf="orderInformation.billingInfo.nameOnBankAccount">

                                <span>{{orderInformation.billingInfo.nameOnBankAccount}}</span>
                            </div>
                        </div>
                        <div class="row" *ngIf="paymentType.eCheck==orderInformation.billingInfo.paymentMethod">
                            <div class="col-sm-5 col-md-5">
                                <span>{{'order.Account Number' |translate}}</span>
                            </div>
                            <div class="col-sm-7 col-md-7 text-right" *ngIf="!orderInformation.billingInfo.accountNumber">
                                <span>{{'customer-service.NA' |translate}}</span>
                            </div>
                            <div class="col-sm-7 col-md-7 text-right" *ngIf="orderInformation.billingInfo.accountNumber">

                                <span>Ending with
                                    {{orderInformation.billingInfo.accountNumber.substr(orderInformation.billingInfo.accountNumber.length
                                    - 4)}}</span>
                            </div>
                        </div>
                        <div class="row" *ngIf="paymentType.eCheck==orderInformation.billingInfo.paymentMethod">
                            <div class="col-sm-5 col-md-5">
                                <span>{{'order.Email' |translate}}</span>
                            </div>
                            <div class="col-sm-7 col-md-7 text-right" *ngIf="!orderInformation.billingInfo.email">
                                <span>{{'customer-service.NA' |translate}}</span>
                            </div>
                            <div class="col-sm-7 col-md-7 text-right" *ngIf="orderInformation.billingInfo.email">

                                <span>{{orderInformation.billingInfo.email}}</span>
                            </div>
                        </div>
                        <div class="row" *ngIf="paymentType.eCheck==orderInformation.billingInfo.paymentMethod">
                            <div class="col-sm-5 col-md-5">
                                <span>{{'order.Phone Number' |translate}}</span>
                            </div>
                            <div class="col-sm-7 col-md-7 text-right" *ngIf="!orderInformation.billingInfo.phone">
                                <span>{{'customer-service.NA' |translate}}</span>
                            </div>
                            <div class="col-sm-7 col-md-7 text-right" *ngIf="orderInformation.billingInfo.phone">

                                <span>{{orderInformation.billingInfo.phone}}</span>
                            </div>
                        </div>
                        <div class="row" *ngIf="paymentType.eCheck==orderInformation.billingInfo.paymentMethod">
                            <div class="col-sm-5 col-md-5">
                                <span>{{'order.Account Type' |translate}}</span>
                            </div>
                            <div class="col-sm-7 col-md-7 text-right" *ngIf="!orderInformation.billingInfo.accountType">
                                <span>{{'customer-service.NA' |translate}}</span>
                            </div>
                            <div class="col-sm-7 col-md-7 text-right" *ngIf="orderInformation.billingInfo.accountType">
                                <span
                                    *ngIf="orderInformation.billingInfo.accountType === AccountTypeConstants.Savings">{{accountTypeEnums.Savings}}</span>
                                <span
                                    *ngIf="orderInformation.billingInfo.accountType === AccountTypeConstants.Checking">{{accountTypeEnums.Checking}}</span>
                            </div>
                        </div>
                         -->
                        <div class="row" *ngIf="paymentType.Credit_Card==orderInformation.billingInfo.paymentMethod || paymentType.BanContact_MisterCash_and_Maestro==orderInformation.billingInfo.paymentMethod">
                            <div class="col-sm-5 col-md-5">
                                <span>{{'order.Cardholder' |translate}}</span>
                            </div>
                            <div class="col-sm-7 col-md-7 text-right" *ngIf="!orderInformation.billingInfo.cardHolderName">
                                <span>{{'customer-service.NA' |translate}}</span>
                            </div>
                            <div class="col-sm-7 col-md-7 text-right" *ngIf="orderInformation.billingInfo.cardHolderName">

                                <span>{{orderInformation.billingInfo.cardHolderName}}</span>
                            </div>
                        </div>
                        <div class="row" *ngIf="paymentType.Credit_Card==orderInformation.billingInfo.paymentMethod || paymentType.BanContact_MisterCash_and_Maestro==orderInformation.billingInfo.paymentMethod">
                            <div class="col-sm-5 col-md-5">
                                <span>{{'customer-service.Card Type' |translate}}</span>
                            </div>
                            <div class="col-sm-7 col-md-7 text-right" *ngIf="!orderInformation.billingInfo.cardType">
                                <span>{{'customer-service.NA' |translate}}</span>
                            </div>
                            <div class="col-sm-7 col-md-7 text-right" *ngIf="orderInformation.billingInfo.cardType">
                                <!-- <span>{{orderInformation.billingInfo.cardType}}</span> -->
                                <!-- <img [src]="getImagePath(orderInformation.billingInfo.cardType)" width="25%"> -->
                                <span class="cc-number"  [ngClass]="orderInformation.billingInfo.cardType | uppercase"></span>
                            </div>
                        </div>
                        <div class="row" *ngIf="paymentType.Credit_Card==orderInformation.billingInfo.paymentMethod || paymentType.BanContact_MisterCash_and_Maestro==orderInformation.billingInfo.paymentMethod">
                            <div class="col-sm-5 col-md-5">
                                <span>{{'customer-service.Card Number' |translate}}</span>
                            </div>
                            <div class="col-sm-7 col-md-7 text-right">
                                <span *ngIf="!orderInformation.billingInfo.maskedCard">NA</span>
                                <span *ngIf="orderInformation.billingInfo.maskedCard">Ending in
                                    {{orderInformation.billingInfo.maskedCard | slice:-4}}</span>
                            </div>
                        </div>
                        <div class="row" *ngIf="paymentType.Credit_Card==orderInformation.billingInfo.paymentMethod || paymentType.BanContact_MisterCash_and_Maestro==orderInformation.billingInfo.paymentMethod">
                            <div class="col-sm-5 col-md-5">
                                <span>{{'order.Expiration' |translate}}</span>
                            </div>
                            <div class="col-sm-7 col-md-7 text-right">
                                <span *ngIf="!orderInformation.billingInfo.expiryMonth">{{'customer-service.NA'
                                    |translate}}</span>
                                <span *ngIf="orderInformation.billingInfo.expiryMonth"><span
                                        *ngIf="orderInformation.billingInfo.expiryMonth.length === 1">0</span>{{orderInformation.billingInfo.expiryMonth}}
                                    / {{orderInformation.billingInfo.expiryYear.substring(2,4)}}</span>
                            </div>
                        </div>
                        <!-- Single/Direct debit payment info starts -->
                        <div class="row"
                            *ngIf="paymentType.Single_Debit==orderInformation.billingInfo.paymentMethod || paymentType.Direct_Debit==orderInformation.billingInfo.paymentMethod">
                            <div class="col-sm-5 col-md-5">
                                <span>{{'order.Bank Account' |translate}}</span>
                            </div>
                            <div class="col-sm-7 col-md-7 text-right" *ngIf="!orderInformation.billingInfo.accountNumber">
                                <span>{{'customer-service.NA' |translate}}</span>
                            </div>
                            <div class="col-sm-7 col-md-7 text-right" *ngIf="orderInformation.billingInfo.accountNumber">
                                <span>Ending with
                                    {{orderInformation.billingInfo.accountNumber.substr(orderInformation.billingInfo.accountNumber.length
                                    - 4)}}</span>
                            </div>
                        </div>
                        <!-- Single/Direct debit payment info ends -->

                        <!-- Ach -->
                        <div class="row" *ngIf="(paymentType.eCheck==orderInformation.billingInfo.paymentMethod) ">
                            <div class="col-sm-5 col-md-5">
                                <span>{{'order.Account Number' |translate}}</span>
                            </div>
                            <div class="col-sm-7 col-md-7 text-right" *ngIf="!orderInformation.billingInfo.accountNumber">
                                <span>{{'customer-service.NA' |translate}}</span>
                            </div>
                            <div class="col-sm-7 col-md-7 text-right" *ngIf="orderInformation.billingInfo.accountNumber">

                                <span>Ending with
                                    {{orderInformation.billingInfo.accountNumber.substr(orderInformation.billingInfo.accountNumber.length
                                    - 4)}}</span>
                            </div>
                        </div>
                        <div class="row" *ngIf="paymentType.eCheck==orderInformation.billingInfo.paymentMethod">
                            <div class="col-sm-5 col-md-5">
                                <span>{{'order.Account Type' |translate |translateKey}}</span>
                            </div>
                            <div class="col-sm-7 col-md-7 text-right" *ngIf="!orderInformation.billingInfo.secType">
                                <span>{{'customer-service.NA' |translate}}</span>
                            </div>
                            <div class="col-sm-7 col-md-7 text-right" *ngIf="orderInformation.billingInfo.secType">

                                <span>{{fetchEcheckSecTypes(orderInformation.billingInfo.secType)}}</span>
                            </div>
                        </div>
                         <div class="row" *ngIf="paymentType.eCheck==orderInformation.billingInfo.paymentMethod">
                            <div class="col-sm-5 col-md-5">
                                <span>{{'order.State' |translate}}</span>
                            </div>
                            <div class="col-sm-7 col-md-7 text-right" *ngIf="!orderInformation.billingInfo.dlState">
                                <span>{{'customer-service.NA' |translate}}</span>
                            </div>
                            <div class="col-sm-7 col-md-7 text-right" *ngIf="orderInformation.billingInfo.dlState">

                                <span>{{orderInformation.billingInfo.dlState}}</span>
                            </div>
                        </div>
                        <div class="row" *ngIf="paymentType.eCheck==orderInformation.billingInfo.paymentMethod">
                            <div class="col-sm-5 col-md-5">
                                <span>{{'order.Driving License Number' |translate}}</span>
                            </div>
                            <div class="col-sm-7 col-md-7 text-right" *ngIf="!orderInformation.billingInfo.dlNumber">
                                <span>{{'customer-service.NA' |translate}}</span>
                            </div>
                            <div class="col-sm-7 col-md-7 text-right" *ngIf="orderInformation.billingInfo.dlNumber">

                                <span>{{orderInformation.billingInfo.dlNumber}}</span>
                            </div>
                        </div>
                        <div class="row" *ngIf="paymentType.eCheck==orderInformation.billingInfo.paymentMethod">
                            <div class="col-sm-5 col-md-5">
                                <span>{{'order.Email' |translate}}</span>
                            </div>
                            <div class="col-sm-7 col-md-7 text-right" *ngIf="!orderInformation.billingInfo.email">
                                <span>{{'customer-service.NA' |translate}}</span>
                            </div>
                            <div class="col-sm-7 col-md-7 text-right" *ngIf="orderInformation.billingInfo.email">

                                <span>{{orderInformation.billingInfo.email}}</span>
                            </div>
                        </div>
                        <div class="row" *ngIf="paymentType.eCheck==orderInformation.billingInfo.paymentMethod">
                            <div class="col-sm-5 col-md-5">
                                <span>{{'order.Phone Number' |translate}}</span>
                            </div>
                            <div class="col-sm-7 col-md-7 text-right" *ngIf="!orderInformation.billingInfo.phone">
                                <span>{{'customer-service.NA' |translate}}</span>
                            </div>
                            <div class="col-sm-7 col-md-7 text-right" *ngIf="orderInformation.billingInfo.phone">

                                <span>{{orderInformation.billingInfo.phone}}</span>
                            </div>
                        </div>
                        <div class="row" *ngIf="(paymentType.Bonus_Check==orderInformation.billingInfo.paymentMethod) ">
                            <div class="col-sm-5 col-md-5">
                                <span>{{'order.Check Number' |translate}}</span>
                            </div>
                            <div class="col-sm-7 col-md-7 text-right" *ngIf="!orderInformation.billingInfo.checkNumber">
                                <span>{{'customer-service.NA' |translate}}</span>
                            </div>
                            <div class="col-sm-7 col-md-7 text-right" *ngIf="orderInformation.billingInfo.checkNumber">
                                <span>{{orderInformation.billingInfo.checkNumber}}</span>
                            </div>
                        </div>


                    </div>
                </div>
            </div>
            <div class="row clearfix"></div>
            <div class="text-left print-hide">
                <a autofocus="" tabindex="0" (click)="openCreateNotesModal()">
                    <span class="glyphicon glyphicon-plus"></span> &nbsp;&nbsp;{{'member-notes.ADD NOTES' |translate |translateKey}}
                </a>
            </div>
            <div class="table-responsive break-all mb-20 print-hide">
                <table class="table table-striped custab">
                    <thead>
                        <tr>
                            <th class="width-239">{{'customer-service.Name' | translate | translateKey}}</th>
                            <th class="width-100">{{'customer-service.Date' | translate | translateKey}}</th>
                            <th class="width-100">{{'customer-service.Time' | translate  | translateKey}}</th>
                            <th>{{'customer-service.Notes' | translate  | translateKey}}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let note of orderNotes">
                            <td>{{note.createdByUserName}}</td>
                            <td>{{note.dateFormat}}</td>
                            <td>{{note.hoursFormat}}</td>
                            <td id="notes-content" class="textarea-format">{{note.note}}</td>
                        </tr>
                        <tr *ngIf="orderNotes.length===0">
                            <td colspan="4" class="text-center">{{'ticketing-system.No records found' | translate | translateKey}}</td>

                        </tr>
                    </tbody>

                </table>
            </div>

            <div class="row clearfix"></div>
            <div class="print-hide">
                <div class="table-responsive">
                    <table class="table table-striped custab">
                        <thead>
                            <tr>
                                <th class="width-125 pointer" tabindex="0" (keyup.enter)="sortTicketsByColumn('TICKET_NUMBER')"
                                    (click)="sortTicketsByColumn('TICKET_NUMBER')">{{'ticketing-system.Ticket #'
                                    |translate}}&nbsp;
                                    <i class="fa fa-sort"
                                        [ngClass]="{'fa-sort': ticketsSortColumn != 'TICKET_NUMBER', 'fa-sort-asc': (ticketsSortColumn  == 'TICKET_NUMBER' && !ticketsIsDesc), 'fa-sort-desc': (ticketsSortColumn  == 'TICKET_NUMBER' && ticketsIsDesc) }"
                                        style="font-size:12px"></i>
                                </th>
                                <th>{{'ticketing-system.Subject' | translate | translateKey}}</th>
                                <th class="width-250 pointer" tabindex="0" (keyup.enter)="sortTicketsByColumn('SUBTYPE')"
                                    (click)="sortTicketsByColumn('SUBTYPE')">{{'ticketing-system.Ticket Subtype' | translate | translateKey}} &nbsp;
                                    <i class="fa fa-sort"
                                        [ngClass]="{'fa-sort': ticketsSortColumn != 'SUBTYPE', 'fa-sort-asc': (ticketsSortColumn  == 'SUBTYPE' && !ticketsIsDesc), 'fa-sort-desc': (ticketsSortColumn  == 'SUBTYPE' && ticketsIsDesc) }"
                                        style="font-size:12px"></i>
                                </th>
                                <th class="width-100 pointer" tabindex="0" (keyup.enter)="sortTicketsByColumn('DUE_DATE')"
                                    (click)="sortTicketsByColumn('DUE_DATE')">{{'ticketing-system.Due Date' | translate | translateKey}}&nbsp;
                                    <i class="fa fa-sort"
                                        [ngClass]="{'fa-sort': ticketsSortColumn != 'DUE_DATE', 'fa-sort-asc': (ticketsSortColumn  == 'DUE_DATE' && !ticketsIsDesc), 'fa-sort-desc': (ticketsSortColumn  == 'DUE_DATE' && ticketsIsDesc) }"
                                        style="font-size:12px"></i>
                                </th>
                                <th class="width-40 pointer" tabindex="0" (keyup.enter)="sortTicketsByColumn('CREATED_DATE')"
                                    (click)="sortTicketsByColumn('CREATED_DATE')">{{'ticketing-system.Created Date'| translate | translateKey}}&nbsp;
                                    <i class="fa fa-sort"
                                        [ngClass]="{'fa-sort': ticketsSortColumn != 'CREATED_DATE', 'fa-sort-asc': (ticketsSortColumn  == 'CREATED_DATE' && !ticketsIsDesc), 'fa-sort-desc': (ticketsSortColumn  == 'CREATED_DATE' && ticketsIsDesc) }"
                                        style="font-size:12px"></i>
                                </th>
                                <th class="width-175 pointer" tabindex="0" (keyup.enter)="sortTicketsByColumn('UPDATED_DATE')"
                                    (click)="sortTicketsByColumn('UPDATED_DATE')">{{'ticketing-system.Last Modified Date'| translate}}&nbsp;
                                    <i class="fa fa-sort"
                                        [ngClass]="{'fa-sort': ticketsSortColumn != 'UPDATED_DATE', 'fa-sort-asc': (ticketsSortColumn  == 'UPDATED_DATE' && !ticketsIsDesc), 'fa-sort-desc': (ticketsSortColumn  == 'UPDATED_DATE' && ticketsIsDesc) }"
                                        style="font-size:12px"></i>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr
                                *ngFor="let ticket of tickets| paginate: { id: orderTicketsId, itemsPerPage: ticketsPageSize, currentPage: ticketsPageNumber, totalItems: ticketsPageCount }">
                                <td *ngIf="isTicketView">
                                    <a tabindex="0" (keyup.enter)="goToViewTicket(ticket.id,ticket.ticketNumber)"
                                        (click)="goToViewTicket(ticket.id,ticket.ticketNumber)">{{ticket.ticketNumber}}</a>
                                </td>
                                <td *ngIf="!isTicketView">{{ticket.ticketNumber}}</td>
                                <td>{{ticket.subject}} </td>
                                <td>{{ticket.subType}}</td>
                                <td>{{ticket.dueDate | date: 'dd-MMM-yyyy'}}</td>
                                <td>{{ticket.createdDate | date: 'dd-MMM-yyyy'}}</td>
                                <td>{{ticket.modifiedDate | date: 'dd-MMM-yyyy'}}</td>
                            </tr>
                        </tbody>
                        <tbody *ngIf="tickets.length === 0">
                            <tr>
                                <td colspan="6" class="text-center">{{'ticketing-system.No records found' |translate |
                                    translateKey}}</td>

                            </tr>
                        </tbody>
                    </table>
                </div>
                <span class="absolute-position" *ngIf="tickets.length > 0">
                    <span>{{ticketsPageCount}} {{'store.record(s) found' |translate | translateKey}}</span>
                </span>
                <pagination-controls (pageChange)="ticketsPageChange($event)" [id]= "orderTicketsId" class="pull-right"></pagination-controls>
            </div>

            <div class="row clearfix"></div>
            <div class="table-responsive mb-20 print-hide">
                <table class="table table-striped custab">
                    <thead>
                        <tr>
                            <th class="width-150">{{'customer-service.Username' | translate | translateKey}}</th>
                            <th class="width-100">{{'customer-service.Date' | translate | translateKey}}</th>
                            <th class="width-100">{{'customer-service.Time' | translate | translateKey}}</th>
                            <th>{{'customer-service.Log' | translate | translateKey}}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let log of orderLogs">
                            <td>{{log.userName}}</td>
                            <td>{{log.dateFormat}}</td>
                            <td>{{log.hoursFormat}}</td>
                            <td>{{log.message}}</td>
                        </tr>
                        <tr *ngIf="orderLogs.length===0">
                            <td colspan="4" class="text-center">{{'ticketing-system.No records found' | translate | translateKey}}</td>

                        </tr>
                    </tbody>

                </table>
            </div>
    </div>
    <div *ngIf="accountCreateNotification" class="col-md-6">
        <div class="account-create-centered account-create-success">
            {{'order.Account successfully created' | translate | translateKey}} <i class="fa fa-check-circle fa-5x account-email-text-color"></i>
        </div>
        <div class="account-signup-centered account-signup-text">
            {{'order.User has signed up for the exclusive Forever Preferred Customer program' | translate | translateKey}}
            <div>
                {{'order.An Email confirmation is sent to' | translate | translateKey}}
                <span class="account-email-text-color">{{orderInfo.emailID}}</span>
            </div>
        </div>
    </div>

</section>
<modal #cancelOrderModal class="cancel-modal">
    <modal-header>
        <div class="color-blue">{{'order.CANCEL / REFUND ORDER' | translate |translateKey}}
            <span *ngIf="orderCancelForm && orderInformation.source === 'POS'" class="fa-close-icon" (click)="closePopup()">
                <i class="fa fa-close"></i>
            </span>
            <div class="header-info">
              <div> {{'order.Are you sure you want to proceed? Please select from the options below. You will not be able to reverse this action once submitted. If the order is from a closed bonus period, the bonus correction will need to be completed in the AS400 and/or applicable systems outside of Titan.' |translate  |translateKey}}</div>
            </div>
      </div>
    </modal-header>
    <modal-content>
        <div *ngIf="orderCancelForm" class="orderCancelForm">
            <form [formGroup]="orderCancelForm" novalidate>
                <div class="cancel-order">
                    <input type="radio" name="cancelAndRefund" value="cancel"
                        id="cancel" formControlName="cancelAndRefund" (click)="onCancelOptionChange('cancel')" tabindex="0"/>
                    <label for="cancel" class="pr-30">{{'order.Cancel'|translate |translateKey}}
                    </label>
                </div>
                <div class="cancel-refund-order" *ngIf="showCancelAndRefundRadio">
                    <input  type="radio" name="cancelAndRefund" value="cancelAndRefund"
                        id="cancelAndRefund" formControlName="cancelAndRefund" (click)="onCancelOptionChange('cancelAndRefund')" tabindex="0"/>
                    <label for="cancelAndRefund" class="pr-30">{{'order.Cancel And Refund'|translate |translateKey}}
                </label>
                </div>
                <div class="floating-input floatLabelContainer mb-10">
                    <span class="col-md-2">{{'order.Reason' |translate | translateKey}}</span>
                    <div class="col-md-9">
                        <select class="form-control ng-pristine ng-invalid ng-touched" formControlName="orderStatusChangeReasonId">
                            <option value="" [selected]="true" disabled>--{{'ticketing-system.Select' |translate | translateKey}}--</option>
                            <option *ngFor="let note of orderStatusChangeReasons" [ngValue]="note.id">{{note.reasonNote}}
                            </option>
                        </select>
                        <div class="alert-msg"
                            *ngIf="!orderCancelForm.controls['orderStatusChangeReasonId'].valid && orderCancelForm.controls['orderStatusChangeReasonId'].touched || submitted">
                            {{'order.Reason note is Mandatory' |translate |translateKey}}
                        </div>
                    </div>
                </div>
                <div class="floating-input floatLabelContainer">
                    <textarea *ngIf="orderInformation.source !== 'POS'; else pos_text" id="orderCancelNotes" float-label type="text" formControlName="notes"
                        class="mb-0 form-control" placeholder="{{'order.Notes' |translate |translateKey}}"></textarea>
                    <ng-template #pos_text>
                        <textarea id="orderCancelNotes" float-label type="text" formControlName="notes"
                        class="mb-0 form-control" placeholder="{{'order.Reason for order cancellation' |translate |translateKey}}"></textarea>
                    </ng-template>
                </div>
                <div class="clearboth text-right mt-10" *ngIf="orderInformation.source !== 'POS'; else cancel_button">
                    <button type="button" class="btn blue-button" (click)="cancelOrder()">
                        {{'distribution-center.Ok'|translate|translateKey}}</button>
                    <button type="button" class="btn remove-btn grey-button" (click)="closePopup()">
                        {{'distribution-center.Cancel'|translate|translateKey}}</button>
                </div>
                <ng-template #cancel_button>
                    <div class="clearboth text-right mt-10">
                        <button type="button" class="btn blue-button" (click)="cancelOrder()">
                            {{'order.CANCEL ORDER'|translate|translateKey}}</button>
                    </div>
                </ng-template>
            </form>
        </div>
    </modal-content>
</modal>
<modal #cancelOrderResponseModal class="order-response-modal">
  <modal-content>
    <div class="header-info text-center fade_In">
      <div *ngIf=" isCancelAlone && bonusDetails?.bonusStatusId == 2 ">
        <div> {{'order.Order was successfully canceled and bonus was removed from the system' |translate |translateKey}}</div>
      </div>
      <div *ngIf="!isCancelAlone && bonusDetails?.bonusStatusId == 2 ">
        <div> {{'order.Order was successfully canceled, bonus was removed from system and order was refunded' |translate |translateKey}}</div>
      </div>
      <div *ngIf="isCancelAlone && bonusDetails?.bonusStatusId == 11 ">
        <div> {{'order.This order was successfully canceled in Titan, Please contact the Bonus Team for bonus correction' |translate }}</div>
      </div>
    </div>
  </modal-content>
  <modal-footer>
    <button type="button" class="btn blue-button" (click)="closePopup()">
      {{'distribution-center.Ok'|translate|translateKey}}
    </button>
  </modal-footer>
</modal>
<modal #orderNotesModal>
    <modal-header>
        <div class="color-blue">{{'order.NEW NOTES' | translate |translateKey}}</div>
    </modal-header>
    <modal-content >
        <div *ngIf="orderNotesForm">
            <form [formGroup]="orderNotesForm" novalidate>
                <div class="floating-input floatLabelContainer">
                    <textarea id="orderNote" float-label type="text" formControlName="ordernotes"
                        class="mb-0 form-control" placeholder="{{'order.Description' |translate |translateKey}}" rows="5"></textarea>
                    <div class="alert-msg"
                        *ngIf="!orderNotesForm.controls['ordernotes'].valid && orderNotesForm.controls['ordernotes'].touched || submitted">
                        {{'order.Description is Mandatory' |translate |translateKey}}
                    </div>
                </div>
                <div class="clearboth text-right mt-10">
                    <button type="button" class="btn blue-button" (click)="AddNotes()">
                        {{'config-system.ADD'|translate|translateKey}}</button>
                    <button type="button" class="btn remove-btn grey-button" (click)="closeOrderNotesPopup()">
                        {{'config-system.CANCEL'|translate|translateKey}}</button>
                </div>
            </form>
        </div>
    </modal-content>
</modal>
<modal #MemberRestrictions>
    <modal-header>
        <div class="color-blue">{{'customer-service.MEMBER RESTRICTIONS' |translate}}</div>
    </modal-header>
    <modal-content>
        <div *ngIf="distributorInfo" class="distributorInfo mar-top-10">
            <div>
                <span class="header-font bold">{{distributorInfo | displayNameFormat}}</span>
            </div>
            <div *ngIf="distributorInfo.displayName && distributorInfo.memberTypeId === memberTypeEnums.DISTRIBUTOR" class="bold">
                <span>{{distributorInfo.displayName | titleCase}}</span>
              </div>
            <div>
                <span>{{distributorInfo.distributorId |distributorIdFormat}} </span>
                <span *ngIf="distributorInfo.level"> | </span>
                <a [routerLink]="" *ngIf="distributorInfo.level">{{distributorInfo.level}}</a>
            </div>
        </div>
        <div class="restrict-order-message modalcontent-section">
            <div>
                {{'customer-service.Creating new orders is not permitted for members in this status' |translate}}.
            </div>
            <div>
                {{'customer-service.Member Status' |translate}}&nbsp;:&nbsp;
                <span *ngIf="memberStatus">{{memberStatus.name}}</span>
                <span *ngIf="!memberStatus">{{'customer-service.NA' |translate | translateKey}}</span>
            </div>
        </div>
        <div class="text-right mar-top-20">
            <button class="btn grey-button" tabindex="0" type="button" (click)="closeRestrictionPopup()">
                {{'customer-service.CLOSE' |translate}}
            </button>
        </div>
    </modal-content>
</modal>
<modal [closeOnEscape]="false" [closeOnOutsideClick]="false" #updateFboIdOfAnOrderModal>
    <modal-header>
        <div class="color-blue">{{'customer-service.CHANGE FBOID ON THE ORDER' |translate |translateKey}}</div>
    </modal-header>
    <modal-content>
        <form *ngIf="FboIDSearchForm" [formGroup]="FboIDSearchForm"
            (ngSubmit)="onSubmitFboSearchForm(FboIDSearchForm.valid)" class="col-xs-12 change-fboid-form"
            novalidate>
            <div class="modalcontent-section">
                <div class="col-xs-12 padding0">
                    <div class="col-xs-12 col-sm-6 no-padding floating-input floatLabelContainer fbo-id">
                        <input float-label type="text" id="distributorID" class="form-control"
                            placeholder="{{'order.Enter New FBO ID'|translate |translateKey}}"
                            formControlName="distributorID" mask="000-000-000-000" minlength="12"
                        >
                        <div class="alert-msg"
                            *ngIf="!FboIDSearchForm.controls['distributorID'].valid && (FboIDSearchForm.controls['distributorID'].touched)">
                            <div *ngIf="FboIDSearchForm.controls['distributorID'].hasError('required')">
                                {{'order.FBO ID is mandatory'|translate | translateKey}}
                            </div>
                            <div *ngIf="FboIDSearchForm.controls['distributorID'].hasError('minlength')">
                                {{'validation-message.Enter valid FBO ID'|translate | translateKey}}
                            </div>
                        </div>
                    </div>
                    <ng-template [ngIf]="isMemberSearchSucess">
                        <div *ngIf="distributorDetailsForValenceSearch && !FPCOrFBONotFoundErrorMessage && !errorMessage && !isNotAuthorizedCountry" class="col-xs-8 padding0 fbo-detail">
                            <div class="col-md-12 text-left">
                                <span class="color-blue uppercase"> {{'order.MEMBER DETAILS' |translate
                                    |translateKey}}</span>
                            </div>
                            <div *ngIf="distributorDetailsForValenceSearch?.displayName" class="pl-10" style="padding-top: 21px;">
                                <span class="bold h4">{{distributorDetailsForValenceSearch.displayName}}</span>
                            </div>
                            <div *ngIf="distributorDetailsForValenceSearch?.fboId" class="mt-10 pl-10">
                                    <a><i class="fa fa-copy"
                                        [copyToClipboard]="distributorDetailsForValenceSearch?.fboId"></i></a>
                                <span><mark>{{distributorDetailsForValenceSearch.fboId |distributorIdFormat}}</mark> </span>
                                <span > | </span>
                                <span *ngIf="distributorDetailsForValenceSearch.memberType"><mark> {{distributorDetailsForValenceSearch.memberType}} </mark></span>
                            </div>
                        </div>
                    </ng-template>
                    <div class="alert-msg col-xs-12 font-20" style="padding-left: 0px;" *ngIf="FPCOrFBONotFoundErrorMessage || errorMessage || notAuthorizedCountryMessage">
                            <div *ngIf="FPCOrFBONotFoundErrorMessage">
                                {{'validation-message.Entered DistributorID is not a FBO/FPC.'|translate | translateKey}}
                            </div>
                            <div *ngIf="errorMessage">
                                {{'validation-message.Member is not available with the entered FBOID.'|translate | translateKey}}
                            </div>
                            <div *ngIf="isNotAuthorizedCountry && notAuthorizedCountryMessage">
                                {{notAuthorizedCountryMessage}}
                            </div>
                    </div>

                </div>
                <ng-template [ngIf]="!isMemberSearchSucess || !distributorDetailsForValenceSearch || FPCOrFBONotFoundErrorMessage || errorMessage || notAuthorizedCountryMessage">
                    <div class="clearboth pull-right mt-20">
                        <button class="btn blue-button" tabindex="0" type="submit"
                            [attr.disabled]="(FboIDSearchForm.valid) ?null:''">
                            {{'config-system.Search' |translate |translateKey}}
                        </button>
                        <button class="btn grey-button" tabindex="0" type="button" (click)="closeupdateFboIdOfAnOrderModalPopup(true)">
                            {{'config-system.CANCEL' |translate |translateKey}}
                        </button>
                    </div>
                </ng-template>
                <ng-template [ngIf]="isMemberSearchSucess && distributorDetailsForValenceSearch && !FPCOrFBONotFoundErrorMessage && !errorMessage && !notAuthorizedCountryMessage">
                    <div class="clearboth pull-right mt-20">
                        <button class="btn blue-button" type="button" tabindex="0" (click)='confirmationModalForUpdatingFboIdOfAnOrder()'>
                            {{'config-system.Ok' |translate |translateKey}}
                        </button>
                        <button class="btn grey-button" tabindex="0" type="button" (click)="closeupdateFboIdOfAnOrderModalPopup(true)">
                            {{'config-system.CANCEL' |translate |translateKey}}
                        </button>
                    </div>
                </ng-template>

            </div>
        </form>
    </modal-content>
</modal>
<modal [closeOnEscape]="false" [closeOnOutsideClick]="false" #confirmOrSuccessFboIdOfAnOrderModal>
    <modal-header>
        <div class="color-blue">{{'customer-service.CHANGE FBOID ON THE ORDER' |translate |translateKey}}</div>
    </modal-header>
    <modal-content>
        <div class="modalcontent-section">
            <ng-template [ngIf]="isConfirmationModalMessage">
                <div  class="col-xs-12 text-center">
                    <span *ngIf= "(memberInfo && (memberInfo.memberTypeId === memberTypeEnums.DISTRIBUTOR ||memberInfo.memberTypeId === memberTypeEnums.FPC) && orderInformation?.orderTypeId !== orderTypeIdForRetail )" class="font-26">{{'customer-service.Are you sure you want to reassign this order to FBOID # '|translate|translateKey}}<b><mark>{{distributorDetailsForValenceSearch.fboId |distributorIdFormat}}</mark>&#63;</b></span>
                    <span *ngIf= "(memberInfo &&  orderInformation?.orderTypeId === orderTypeIdForRetail)" class="font-23">{{'customer-service.Are you sure you want to reassign the sponsor on this order to FBOID # '|translate|translateKey}}<b><mark>{{distributorDetailsForValenceSearch.fboId |distributorIdFormat}}</mark>&#63;</b></span>
                </div>
            </ng-template>
            <ng-template [ngIf]="isDistributorIdChangedSuccessMessage">
                <div class="col-xs-12 text-center">
                    <span *ngIf="(memberInfo && (memberInfo.memberTypeId === memberTypeEnums.DISTRIBUTOR ||memberInfo.memberTypeId === memberTypeEnums.FPC) && orderInformation?.orderTypeId !== orderTypeIdForRetail )" class="font-30">{{'customer-service.This order has been reassigned to FBOID # '|translate|translateKey}}<b><mark>{{distributorDetailsForValenceSearch.fboId |distributorIdFormat}}</mark></b></span>
                    <span *ngIf="(memberInfo && orderInformation?.orderTypeId === orderTypeIdForRetail)" class="font-26">{{'customer-service.The sponsor on this order has been reassigned to FBOID # '|translate|translateKey}}<b><mark>{{distributorDetailsForValenceSearch.fboId |distributorIdFormat}}</mark></b></span>
                </div>
            </ng-template>
            <ng-template [ngIf] = "isConfirmationModalMessage">
                <div class="clearboth pull-right mt-20">
                    <button class="btn blue-button" type="button" tabindex="0" (click)='confirmUpdateFboIdForExistingOrder()'>
                        {{'config-system.Ok' |translate |translateKey}}
                    </button>
                    <button class="btn grey-button" tabindex="0" type="button" (click)="closeconfirmationOrSucessModalForUpdatingFboIdOfAnOrder(true,false)">
                        {{'config-system.CANCEL' |translate |translateKey}}
                    </button>
                </div>
            </ng-template>
            <ng-template [ngIf]="isDistributorIdChangedSuccessMessage">
                <div class="text-center col-xs-12">
                    <button class="btn blue-button" type="button" tabindex="0" (click)='closeconfirmationOrSucessModalForUpdatingFboIdOfAnOrder(false,true)'>
                        {{'config-system.Ok' |translate |translateKey}}
                    </button>
                </div>
            </ng-template>
        </div>
    </modal-content>
</modal>

<modal [closeOnEscape]="false" [closeOnOutsideClick]="false" #processingPeriodModal class="processingPeriodModal ">
    <modal-header>
        <div class="color-blue fs-19">
            {{ (submitProcessOrder ? 'customer-service.Confirm Processing Period For the Order' : 'customer-service.Change Processing Period For the Order' ) |translate |translateKey}}
        </div>
    </modal-header>
    <modal-content>
        <div class="modalcontent-section">
            <div class="modal_overlay" *ngIf="!selectedBonusPeriod">
                <div class="spinner"><i class="fa fa-spinner fa-spin spinner_icon fa-2x "></i></div>
            </div>
            <div class="processing-section row fade_In">
                <div class="processing-month col-sm-6 fade_In" *ngIf="!submitProcessOrder">
                    <label>{{'customer-service.Processing Period' |translate | translateKey}}</label>
                    <select class="form-control" [(ngModel)]="selectedBonusPeriod">
                        <option disabled>--{{'ticketing-system.Select' |translate | translateKey}}--</option>
                        <option [disabled]="bonus.disabled" *ngFor="let bonus of bonusStatuses" [ngValue]="bonus">
                            {{bonus?.month |slice:0:3}}/{{bonus?.year}} - {{bonus?.status |titlecase}}</option>
                    </select>
                    <div class="alert-msg fade_In" *ngIf="selectedBonusPeriod?.error && selectedBonusPeriod?.errMsg"
                        style="padding:3px">
                        {{selectedBonusPeriod?.errMsg }}
                    </div>
                </div>

                <div *ngIf="submitProcessOrder" class="confirm-dialog col-sm-12 fade_In text-center"
                    style="padding-bottom: 20px;">
                    <span class="text-center fs-17">
                        {{'customer-service.Are you sure want to update the Processing Period from' |translate | translateKey}}
                        <b>{{orderInformation?.processedMonth <= 9 ? '0'+(orderInformation.processedMonth) : orderInformation?.processedMonth}}/{{orderInformation?.processedYear?.toString() |slice:2:4}}</b>
                        {{'customer-service.to'|translate | translateKey}}
                        <b>{{selectedBonusPeriod?.processedMonth <= 9 ? '0'+(selectedBonusPeriod.processedMonth) : selectedBonusPeriod?.processedMonth }}/{{selectedBonusPeriod?.year?.toString() |slice:2:4}}</b>
                        {{'customer-service.for this Order'|translate | translateKey}} ?</span>
                </div>

            </div>
            <div class="flex gap_1 " [ngClass]="submitProcessOrder? 'flex_center fade_In': 'flex_end fade_In'">
                <button *ngIf="!submitProcessOrder" class="btn blue-button" type="button" tabindex="0"
                    [disabled]="(selectedBonusPeriod?.error && selectedBonusPeriod?.errMsg) || (orderInformation?.processedMonth == selectedBonusPeriod?.processedMonth)"
                    (click)="submitProcessingPeriod()">{{'common.Submit' | translate | translateKey}}</button>
                <button *ngIf="submitProcessOrder" class="btn blue-button" type="button" tabindex="0"
                    (click)="confirmProcessingPeriod()">{{'config-system.Yes' |translate | translateKey |uppercase }}</button>
                <button class="btn grey-button" type="button" tabindex="0"
                    (click)="closeProcessingPeriod()">{{ (submitProcessOrder ?  'customer-service.No' : 'config-system.CANCEL') |translate |translateKey |uppercase }}</button>
            </div>
        </div>
    </modal-content>
</modal>


<div *ngIf="showprint">
<app-print-layout [orderStoreInfo]="storeInfo" [orderDetails]="orderInformation" [distributorInfo]="memberInfo" [countries]="participatingCountries" [storeMetaInfo]="storeMetadata"></app-print-layout>
</div>



// WEBPACK FOOTER //
// ./src/app/customerservice/templates/template1/views/recent-order-view.component.html